import styled from 'styled-components';

export const Container = styled.div``;

export const TextBlock = styled.p``;

export const Wrapper = styled.div`
  margin-bottom: 24px;
`;
